import LengthQuestion from './LengthQuestion';

export default LengthQuestion;
